export type PremiumFeature =
  | 'serverSync'
  | 'unlimitedSharedEvents'
  | 'unlimitedDevicesPerEvent'
  | 'adminPanel'
  | 'qrLibraryPublish'
  | 'advancedFraudControls';

export type EntitlementSource = 'none' | 'play_subscription' | 'gift_token' | 'revenuecat' | 'both';

export interface FreeTierLimits {
  maxActiveSharedEvents: number;
  maxDevicesPerSharedEvent: number;
}

export interface FeaturePlanMatrix {
  free: {
    features: PremiumFeature[];
    limits: FreeTierLimits;
  };
  complete: {
    features: PremiumFeature[];
    limits: null;
  };
}

export const FREE_TIER_LIMITS: FreeTierLimits = {
  maxActiveSharedEvents: 1,
  maxDevicesPerSharedEvent: 2
};

export const FEATURE_PLAN_MATRIX: FeaturePlanMatrix = {
  free: {
    features: [],
    limits: FREE_TIER_LIMITS
  },
  complete: {
    features: [
      'serverSync',
      'unlimitedSharedEvents',
      'unlimitedDevicesPerEvent',
      'adminPanel',
      'qrLibraryPublish',
      'advancedFraudControls'
    ],
    limits: null
  }
};

export const ENTITLEMENT_STORAGE_KEYS = {
  LAST_SYNCED_AT: 'billing_last_synced_at',
  STATE: 'billing_entitlement_state',
  GIFT_REDEEM_HISTORY: 'gift_redeem_history'
} as const;
